import React, { Component } from 'react';
import DateTime from 'react-datetime';
import moment from 'moment';
import 'moment/locale/fr';

import Exporter from './../../Core/Exporter';

class BtnGroup extends Component {
  constructor(props) {
    super(props);

    this.handleDate = this.handleDate.bind(this);

    this.DateTimeStart = React.createRef();
    this.DateTimeEnd = React.createRef();
  }

  handleDate(ref, name, date) {
    if (date._isAMomentObject != null) {
      let evt = {
        target: {
          name: name,
          value: date.unix()
        },
      };
      this.props.handleFilterChange(evt);
    } else if(date === ""){
      let evt = {
        target: {
          name: name,
          value: null
        },
      };
      this.props.handleFilterChange(evt);
    }
  }

  render() {
    return (
      <div className='btn-toolbar float-right' role='toolbar'>
        <div className='custom-control custom-switch my-auto pr-2'>
          <input
            type='checkbox'
            className='custom-control-input'
            id='allColumnsToggle'
            checked={this.props.allColumnsToggled}
            onClick={this.props.onToggle}
          />
          <label className='custom-control-label text-secondary' htmlFor='allColumnsToggle'>
            Toutes les colonnes
          </label>
        </div>
        <span className='my-auto'>Du :</span>
        <div className='mr-2' ref={this.DateTimeStart} style={{ width: '110px' }}>
          <DateTime
            name='date'
            timeFormat={false}
            onChange={(date) => {
              this.handleDate(this.DateTimeStart, 'startDate', date);
            }}
            dateFormat='DD/MM/YYYY'
            locale='fr'
            value={this.props.startDate != null ? this.props.startDate * 1000 : null}
            closeOnSelect={true}
          />
        </div>
        <span className='my-auto'>au :</span>
        <div className='mr-2' ref={this.DateTimeEnd} style={{ width: '110px' }}>
          <DateTime
            name='date'
            timeFormat={false}
            onChange={(date) => {
              this.handleDate(this.DateTimeEnd, 'endDate', date);
            }}
            dateFormat='DD/MM/YYYY'
            locale='fr'
            value={this.props.endDate != null ? this.props.endDate * 1000 : null}
            closeOnSelect={true}
          />
        </div>
        <span className='my-auto'>Vendue :</span>
        <select className='btn btn-outline-secondary mx-2' name='sold' value={this.props.sold} onChange={this.props.handleFilterChange} required>
          <option key={'sold-0'} value={0}>
            Non
          </option>
          <option key={'sold-1'} value={1}>
            Oui
          </option>
        </select>
        <span className='my-auto'>Afficher :</span>
        <span className='dropdown mx-2'>
          <button
            className='btn btn-outline-secondary dropdown-toggle'
            type='button'
            id='dropdownMenuButton'
            data-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='false'
          >
            Sélectionnez
          </button>
          <div className='dropdown-menu px-2 pb-0' aria-labelledby='dropdownMenuButton'>
            <div className='form-group'>
              <div className='form-check'>
                <input
                  type='radio'
                  className='form-check-input'
                  id='dropdownRisky'
                  name='dropdown-stacked'
                  onClick={() =>
                    this.props.handleFilterChange({
                      target: {
                        name: 'param',
                        value: 'risky',
                      },
                    })
                  }
                />
                <label className='form-check-label text-nowrap' htmlFor='dropdownRisky'>
                  Offres à risques
                </label>
              </div>
            </div>
            <div className='form-group'>
              <div className='form-check'>
                <input
                  type='radio'
                  className='form-check-input'
                  id='dropdownBest'
                  name='dropdown-stacked'
                  onClick={() =>
                    this.props.handleFilterChange({
                      target: {
                        name: 'param',
                        value: 'best',
                      },
                    })
                  }
                />
                <label className='form-check-label text-nowrap' htmlFor='dropdownBest'>
                  Meilleure offre possible
                </label>
              </div>
            </div>
            <div className='form-group'>
              <div className='form-check'>
                <input
                  type='radio'
                  className='form-check-input'
                  id='dropdownWeek'
                  name='dropdown-stacked'
                  onClick={() =>
                    this.props.handleFilterChange({
                      target: {
                        name: 'param',
                        value: 'week',
                      },
                    })
                  }
                />
                <label className='form-check-label text-nowrap' htmlFor='dropdownWeek'>
                  Semaine en cours
                </label>
              </div>
            </div>
            <div className='form-group'>
              <div className='form-check'>
                <input
                  type='radio'
                  className='form-check-input'
                  id='dropdownMonth'
                  name='dropdown-stacked'
                  onClick={() =>
                    this.props.handleFilterChange({
                      target: {
                        name: 'param',
                        value: 'month',
                      },
                    })
                  }
                />
                <label className='form-check-label text-nowrap' htmlFor='dropdownMonth'>
                  Mois en cours
                </label>
              </div>
            </div>
          </div>
        </span>
        <div className='btn-group mr-2' role='group'>
          <button
            type='button'
            className='btn btn-primary'
            onClick={() =>
              this.props.handleFilterChange({
                target: {
                  name: 'param',
                  value: '',
                },
              })
            }
          >
            Tout afficher
          </button>
        </div>
        <span className='float-right my-auto mr-3' data-toggle='modal' data-target='#addProposalModal' onClick={() => this.props.clearProposal()}>
          <a href='#'>
            <li className='fas fa-plus'></li> <u>Ajouter une offre</u>
          </a>
        </span>
        <span className='float-right my-auto mr-2'>
          <a
            href='#'
            onClick={() => {
              Exporter.Instance.ExportCSV('Proposal', this.props.user_dealerships);
            }}
          >
            <li className='fas fa-file-export'></li> <u>Exporter</u>
          </a>
        </span>
      </div>
    );
  }
}

export default BtnGroup;



// WEBPACK FOOTER //
// ./src/Components/Proposal/BtnGroup.js